import './paragontheaters/style';
import FormStructure from './paragontheaters/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js